import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import ArrowheadRight from '@elliemae/ds-icons/ArrowheadRight';
import ArrowheadDown from '@elliemae/ds-icons/ArrowheadDown';
import GroupItem from '@elliemae/ds-shared/GroupContext/GroupItem';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { PropTypes, describe } from 'react-desc';
import DSAccordionHeader from './DSAccordionHeader.js';
import '@elliemae/ds-system';
import '@elliemae/ds-icons/ChevronDown';
import '@elliemae/ds-icons/ChevronRight';
import '@elliemae/ds-button';
import './DSAccordionHeaderActions.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import './blocks.js';
import './DSAccordionHeaderTitle.js';
import '@elliemae/ds-truncated-tooltip-text';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ICON_SIZE = 's';
var INCREMENT = 8;
var QTY_PADDING = 40;

var _convertPropToCssClas = convertPropToCssClassName('accordion-item'),
    cssClassName = _convertPropToCssClas.cssClassName,
    classNameElement = _convertPropToCssClas.classNameElement;

var DSAccordionItem = /*#__PURE__*/function (_Component) {
  _inherits(DSAccordionItem, _Component);

  var _super = _createSuper(DSAccordionItem);

  function DSAccordionItem(props) {
    var _this;

    _classCallCheck(this, DSAccordionItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setHeight", function (element) {
      var actualHeight = _this.state.actualHeight;
      setTimeout(function () {
        var _element$getBoundingC = element.getBoundingClientRect(),
            height = _element$getBoundingC.height;

        if (height) {
          var newHeight = INCREMENT * QTY_PADDING + height;
          if (actualHeight === newHeight) return;

          _this.setState({
            actualHeight: 'auto' // newHeight,

          });
        }
      }, 0);
    });

    _this.childElements = /*#__PURE__*/React.createRef();
    _this.state = {
      actualHeight: null
    };
    return _this;
  }

  _createClass(DSAccordionItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setHeight(this.childElements.current);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var expandable = this.props.expandable;

      if (expandable) {
        this.setHeight(this.childElements.current);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          secondaryTitle = _this$props.secondaryTitle,
          customActions = _this$props.customActions,
          value = _this$props.value,
          idx = _this$props.idx,
          iconOpened = _this$props.iconOpened,
          iconClosed = _this$props.iconClosed,
          setTabRef = _this$props.setTabRef,
          handleKeyPress = _this$props.handleKeyPress;
      var actualHeight = this.state.actualHeight;
      return /*#__PURE__*/React.createElement(GroupItem, {
        render: function render(context) {
          var _React$createElement;

          var activeValue = context.activeValue;
          var selected = activeValue !== undefined && (activeValue === value || activeValue.length && activeValue.indexOf(value) > -1);
          var OpenedCloseIcon = selected ? iconOpened : iconClosed;
          return /*#__PURE__*/React.createElement("div", {
            className: cssClassName,
            "data-testid": "ds-accordion_item"
          }, /*#__PURE__*/React.createElement(DSAccordionHeader, {
            customActions: customActions,
            icon: /*#__PURE__*/React.createElement(OpenedCloseIcon, {
              size: ICON_SIZE
            }),
            idx: idx,
            onClick: function onClick() {
              return context.onChange(value);
            },
            onKeyDown: function onKeyDown(e) {
              return handleKeyPress(idx, e);
            },
            secondaryTitle: secondaryTitle,
            selected: selected,
            setTabRef: setTabRef,
            title: title
          }), /*#__PURE__*/React.createElement("div", (_React$createElement = {
            "data-testid": "ds-accordion_item-content",
            "aria-hidden": !selected,
            "aria-labelledby": "accordion_".concat(idx, "id"),
            className: "".concat(classNameElement('container'), " ").concat(selected ? 'expanded' : 'closed')
          }, _defineProperty(_React$createElement, "data-testid", "ds-accordion_item-content"), _defineProperty(_React$createElement, "id", "sec".concat(idx)), _defineProperty(_React$createElement, "role", "region"), _defineProperty(_React$createElement, "style", {
            height: selected ? actualHeight : 0
          }), _React$createElement), /*#__PURE__*/React.createElement("div", {
            ref: _this2.childElements,
            className: classNameElement('expand-zone')
          }, /*#__PURE__*/React.createElement("div", {
            className: classNameElement('expand-zone-space')
          }, selected && children))));
        }
      });
    }
  }]);

  return DSAccordionItem;
}(Component);

var props = {
  /** accordion content */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired.description('accordion content'),

  /** accordion title */
  title: PropTypes.string.description('accordion title'),

  /** accordion item value, for selected */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired.description('accordion item value, for selected'),

  /** icon for closed accordion */
  iconClosed: PropTypes.node.description('icon for closed accordion'),

  /** icon for open accordion */
  iconOpened: PropTypes.node.description('icon for open accordion'),

  /** secondary title */
  secondaryTitle: PropTypes.string.description('secondary title'),

  /** accordion item custom actions */
  customActions: PropTypes.arrayOf(PropTypes.object).description('accordion item custom actions')
};
DSAccordionItem.propTypes = props;
DSAccordionItem.defaultProps = {
  iconClosed: function iconClosed() {
    return /*#__PURE__*/React.createElement(ArrowheadRight, {
      width: "20px",
      color: ['brand-primary', 800]
    });
  },
  iconOpened: function iconOpened() {
    return /*#__PURE__*/React.createElement(ArrowheadDown, {
      width: "20px",
      color: ['brand-primary', 800]
    });
  },
  title: '',
  secondaryTitle: null,
  customActions: null
};
var DSAccordionItemWithSchema = describe(DSAccordionItem);
DSAccordionItemWithSchema.propTypes = props;

export default DSAccordionItem;
export { DSAccordionItem, DSAccordionItemWithSchema };
//# sourceMappingURL=DSAccordionItem.js.map
